export default class DistanceToShore extends React.Component {
  constructor (props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.shore_distances != null && nextProps.value != null;
  }

  handleChange(event) {
    let val = parseInt(event.target.value);

    if (val === this.props.value) {
      val = 0
    }

    this.props.filter('shoreDistance', val);
  }

  distanceBlock(distance, i) {
    let value = i + 1;

    return (
      <div className="mdc-form-field main-form-radio"
           key={i}
           onClick={ () => { $(`.input_to_shore${i}`).trigger('click') } }
      >
        <div className="mdc-radio">
          <input className={`mdc-radio__native-control input_to_shore${i}`}
                 type="radio"
                 onClick={(event) => { event.stopPropagation(); }}
                 onChange={this.handleChange}
                 value={value}
                 checked={this.props.value == value}
          />

          <div className="mdc-radio__background">
            <div className="mdc-radio__outer-circle"></div>

            <div className="mdc-radio__inner-circle"></div>
          </div>
        </div>

        <label>
          {distance}
        </label>
      </div>
    );
  }

  distancesBlock() {
    let distances = this.props.shore_distances || [];

    return distances.map((distance, i) => {
      if (this.props.counts && i + 1 != this.props.value && !this.props.counts[i + 1]) {
        return null;
      }
      return this.distanceBlock(`До ${distance} м`, i);
    });
  }

  render() {
    return (
      <div className="filter-row">
        <div className="filter-row__title">
          Расстояние до берега
        </div>
        {this.distanceBlock("Не важно", -1)}
        {this.distancesBlock()}
      </div>
    );
  }
}
